module.exports = [{
      plugin: require('C:/Users/Jan/Desktop/Jan/projects/3#Gatsby/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"C:\\Users\\Jan\\Desktop\\Jan\\projects\\3#Gatsby\\src\\components\\Layout.js"},
    },{
      plugin: require('C:/Users/Jan/Desktop/Jan/projects/3#Gatsby/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('C:/Users/Jan/Desktop/Jan/projects/3#Gatsby/node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://johnflowerbouquet.github.io"},
    },{
      plugin: require('C:/Users/Jan/Desktop/Jan/projects/3#Gatsby/node_modules/gatsby-plugin-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-133286846-1","head":true,"anonymize":true},
    },{
      plugin: require('C:/Users/Jan/Desktop/Jan/projects/3#Gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
